import Container from './container'
export default Container



// WEBPACK FOOTER //
// ./src/components/GlobalNav/index.js